import { Typography } from '@/components';
import ShoppingBag from '@/public/images/icons/shopping_bag.svg';
import styled from 'styled-components';
import type { LogoSize } from '../../ShipmentLogo';

export const MerchantLogoImage = styled.img({
  objectFit: 'contain',
  objectPosition: 'center',
  width: '100%',
  height: '100%',
});

export const DefaultLogo = styled(ShoppingBag)({ fill: '#B9BFC4' });

export const MerchantFirstLetter = styled(Typography).attrs({
  type: 'span',
})(({ theme }) => ({
  fontWeight: theme.fontWeight.semiBold,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1,
  color: theme.colors.surface04,
}));

export const MerchantFirstLetterBackground = styled.div(({ theme }) => ({
  backgroundColor: '#B9BFC4',
  borderRadius: 100,
  border: `1px solid ${theme.colors.surface04}`,
  position: 'absolute',
}));

export const FirstLetterWrapper = styled.div({
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const MerchantLogoWraper = styled.div<{
  size?: LogoSize;
  hasLogo?: boolean;
}>(({ size, hasLogo, theme }) => ({
  position: 'relative',
  width: size === 'large' ? 60 : 40,
  height: size === 'large' ? 60 : 40,
  padding: size === 'large' ? theme.spacing[8] : theme.spacing[6],
  borderRadius: 2,
  border: `1px solid ${theme.colors.surface05}`,
  backgroundColor: hasLogo ? theme.colors.highEmphasisWhite : theme.colors.surface04,
  overflow: 'hidden',

  [`${FirstLetterWrapper}`]: {
    right: size === 'large' ? 14 : 7,
    bottom: size === 'large' ? 11 : 6,
  },

  [`${MerchantFirstLetterBackground}`]: {
    width: size === 'large' ? 20 : 16,
    height: size === 'large' ? 20 : 16,
  },

  [`${MerchantFirstLetter}`]: {
    fontSize: size === 'large' ? theme.fontSizes[14] : theme.fontSizes[10],
    lineHeight: size === 'large' ? theme.fontSizes[18] : theme.fontSizes[10],
  },
}));
